/** German strings for the device performance test and graphics panels. Keys are the exact English source text. */
export const DE_PERFORMANCE: Readonly<Record<string, string>> = {
  'SYSTEM CHECK': 'SYSTEMCHECK',
  'SKIP': 'ÜBERSPRINGEN',
  'SKIP TEST': 'TEST ÜBERSPRINGEN',
  'QUALITY TIERS': 'QUALITÄTSSTUFEN',
  'GPU': 'GPU',
  'DISPLAY': 'DISPLAY',
  'DEVICE CALIBRATION · A FEW SECONDS': 'GERÄTE-KALIBRIERUNG · WENIGE SEKUNDEN',
  'TUNING THE NIGHT': 'WIR STIMMEN DIE NACHT',
  'FOR YOUR DEVICE': 'AUF DEIN GERÄT AB',
  'A short test drive renders lights, shadows, reflections and bloom at every quality tier. Nightshift then switches on exactly what your device holds at 60 FPS.':
    'Eine kurze Testfahrt rendert Licht, Schatten, Spiegelungen und Bloom in jeder Qualitätsstufe. Danach schaltet Nightshift genau das ein, was dein Gerät mit 60 FPS schafft.',
  'Test progress': 'Testfortschritt',
  'Preparing shaders…': 'Shader werden vorbereitet…',
  'Warming up the GPU…': 'GPU wärmt sich auf…',
  'Timing {tier} — lights, shadows, post-processing': 'Messe {tier} — Licht, Schatten, Nachbearbeitung',
  'Measuring the processor…': 'Prozessor wird gemessen…',
  'Choosing your settings…': 'Einstellungen werden gewählt…',
  'SKIPPED': 'AUSGELASSEN',
  'CALIBRATION COMPLETE · SAVED ON THIS DEVICE': 'KALIBRIERUNG FERTIG · AUF DIESEM GERÄT GESPEICHERT',
  'YOUR SETUP': 'DEIN SETUP',
  'EXPECTED': 'ERWARTET',
  'RESOLUTION': 'AUFLÖSUNG',
  '{scale}% RES': '{scale} % AUFL.',
  'GPU SCORE': 'GPU-WERT',
  'CPU SCORE': 'CPU-WERT',
  'Neon glow': 'Neonleuchten',
  'Moon and lamp shadows': 'Mond- und Laternenschatten',
  'AMBIENT OCCLUSION': 'UMGEBUNGSVERDECKUNG',
  'Plus wet-road reflections': 'Plus Spiegelungen auf nasser Straße',
  'CAR REFLECTIONS': 'AUTO-SPIEGELUNGEN',
  'Live city on the paint': 'Die Stadt spiegelt sich im Lack',
  'Fire and blast shimmer': 'Flimmern über Feuer und Explosionen',
  'Stable 30 FPS': 'Stabile 30 FPS',
  'Smooth 60 FPS': 'Flüssige 60 FPS',
  'On': 'An',
  'Off': 'Aus',
  'Adaptive performance stays on and fine-tunes resolution during races. Change anything later under GRAPHICS at the top or in Settings › Video.':
    'Die adaptive Leistung bleibt aktiv und passt die Auflösung im Rennen fein an. Ändern kannst du alles später über GRAFIK oben oder in Einstellungen › Video.',
  'TEST AGAIN': 'NOCHMAL TESTEN',
  'LET’S RACE': 'AB IN DIE NACHT',
  'CALIBRATION UNAVAILABLE': 'KALIBRIERUNG NICHT MÖGLICH',
  'NO TEST DRIVE': 'KEINE TESTFAHRT',
  'THIS TIME': 'DIESMAL',
  'The browser did not give the test a 3D context. Nightshift keeps its automatic estimate and still adapts during races.':
    'Der Browser hat dem Test keinen 3D-Kontext gegeben. Nightshift behält die automatische Schätzung und passt sich im Rennen weiter an.',
  'Unknown GPU': 'Unbekannte GPU',
  'TESTED: {tier}': 'GETESTET: {tier}',
  'TEST SKIPPED': 'TEST ÜBERSPRUNGEN',
  'NOT TESTED YET': 'NOCH NICHT GETESTET',
  '{fps} FPS expected · GPU {gpu} · {date}': '{fps} FPS erwartet · GPU {gpu} · {date}',
  'A short test drive picks the best quality your device holds at 60 FPS.': 'Eine kurze Testfahrt wählt die beste Qualität, die dein Gerät mit 60 FPS hält.',
  'RUN TEST': 'TEST STARTEN',
  'Graphics and performance test': 'Grafik und Leistungstest',
  'video|GRAPHICS': 'GRAFIK',
  'TESTED': 'GETESTET',
  'Available in the lobby, the menu or after the race.': 'In der Lobby, im Menü oder nach dem Rennen verfügbar.',
  'Contact shading and wet-road reflections. High and Ultra only.': 'Kontaktschatten und Spiegelungen auf nasser Straße. Nur Hoch und Ultra.',
  'Paint mirrors the live city around you. High and Ultra only.': 'Der Lack spiegelt die Stadt um dich herum. Nur Hoch und Ultra.',
  'YOUR GRAPHICS · TESTED {date}': 'DEINE GRAFIK · GETESTET AM {date}',
  'CUSTOM': 'EIGENE',
  'NOT TESTED': 'NICHT GETESTET',
  'RECOMMENDED': 'EMPFOHLEN',
  'Effects': 'Effekte',
  'Available on HIGH and ULTRA': 'Ab HOCH verfügbar',
  'Not available on LOW': 'Auf NIEDRIG nicht verfügbar',
  'HIGH and ULTRA only': 'Nur HOCH und ULTRA',
  'Not on LOW': 'Nicht auf NIEDRIG',
  'Your own setup is saved and shown live behind this panel.': 'Dein eigenes Setup ist gespeichert und läuft live hinter diesem Fenster.',
  'Back to recommended': 'Zurück zur Empfehlung',
  'Pick a tier or switch an effect to override the suggestion; the drive behind shows it live. Adaptive performance keeps fine-tuning resolution in races.':
    'Wähl eine Stufe oder schalte Effekte, um die Empfehlung zu überschreiben – die Fahrt dahinter zeigt es live. Die adaptive Leistung passt die Auflösung im Rennen weiter an.',
  'DONE': 'FERTIG',
  'ADJUST': 'ANPASSEN',
  'YOUR CHOICE: {tier}': 'DEINE WAHL: {tier}',
  'Recommended: {tier} · GPU {gpu}': 'Empfohlen: {tier} · GPU {gpu}',
};
